<template>

    <div class="row h-100 justify-content-center align-items-center bg-info text-light">

        <div class="col-sm-8 col-11" v-if="idea">

            <h1>Idea</h1>

            <div class="form-group mt-4">

                <label for="idea_nombre">Beneficio que se obtendrá</label>

                <input type="text" class="form-control" v-model="idea.beneficio" />

            </div>

            <div class="form-group mt-4">

                <label for="idea_nombre">¿En que criterio impactará?</label>

                <div class="text-left">

                    <div class="custom-control custom-checkbox" v-for="choice in choices" :key="choice">

                        <input
                            type="checkbox"
                            :value="choice"
                            :id="`check-` + choice"
                            v-model="idea.criterio"
                            class="custom-control-input"
                        />

                        <label class="custom-control-label" :for="`check-` + choice">{{ choice }}</label>

                    </div>

                </div>

            </div>

            <button class="btn w-100 btn-light btn-lg mt-4" :disabled="disabled" @click="set"> Guardar </button>

        </div>

    </div>

</template>

<script>
import axios from "axios";
import router from "../router";
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            idea: null,
            choices: ["Costo", "Tiempo", "Calidad", "Otro"],
            ...mapGetters(["getIdea", "getUser"]),
        };
    },
    mounted() {
        this.idea = this.getIdea();
    },
    computed: {
        disabled: function() {
            return this.idea.criterio.length == 0 || !this.idea.beneficio;
        },
    },
    methods: {
        set() {
            this.setIdea(this.idea);
            axios
                .post("/api/funnel/ideas", { idea: this.idea, user: this.getUser() })
                .then(() => {
                    router.push("IdeaFinish");
                })
                .catch((err) => {
                    console.log(err);
                    alert("Hubo un error al guardar la idea");
                });
        },
        ...mapActions(["setIdea"]),
    },
};
</script>

